import { useEffect, useState } from "react";
import axios from "axios";
import { IMG } from "../data/site";

// FIXED: Points to a clean relative path instead of the empty environment variable
const API = "/api";
const FALLBACK_IMG = { Apartment: IMG.apartment1, Plot: IMG.plots, Villa: IMG.villa1, Commercial: IMG.commercial, Studio: IMG.apartment2, Resale: IMG.apartment2 };

export const fromListing = (l) => ({
  id: l.id, project: l.project, category: l.category, config: l.config || "-", size: l.size || "-", price: l.price,
  priceValue: l.price_value ?? 0, priceOnRequest: l.price_value == null, status: l.status, possession: l.possession || "On request",
  floor: "-", facing: "-", rera: "Verify on UP RERA portal", highlights: l.highlights?.length ? l.highlights : ["Newly listed by the Radiance desk"],
  listing: l.listing, purpose: ["End Use", "Investment"], image: FALLBACK_IMG[l.category] || IMG.apartment1, isNew: true,
});

export function useLiveListings() {
  const [live, setLive] = useState([]);
  useEffect(() => {
    // FIXED: Queries the static listings.json file inside the /api folder
    axios.get(`${API}/listings.json`)
      .then((r) => setLive(r.data.map(fromListing)))
      .catch(() => setLive([]));
  }, []);
  return live;
}
